/**
 * The harness stores tool inputs as a free-form record.
 * `run_computer_use_task` carries the user-facing goal under `raw_task`.
 * Fall back to `task` / `goal` / `prompt` for older runs, and
 * `message` for the SubAgentBinding shape.
 */
export const readTaskFromInput = (
  input: Record<string, unknown> | undefined
): string | undefined => {
  if (!input) return undefined;
  for (const key of ['raw_task', 'task', 'goal', 'prompt', 'message'] as const) {
    const value = input[key];
    if (typeof value === 'string' && value.trim()) return value;
  }
  return undefined;
};

/**
 * Reads the `success_criteria` field the project agent attaches when
 * delegating a desktop task. Tolerates `criteria` / `done_when` for
 * future-proofing if the tool schema renames.
 */
export const readSuccessCriteriaFromInput = (
  input: Record<string, unknown> | undefined
): string | undefined => {
  if (!input) return undefined;
  for (const key of ['success_criteria', 'criteria', 'done_when'] as const) {
    const value = input[key];
    if (typeof value === 'string' && value.trim()) return value;
  }
  return undefined;
};
